import * as tslib_1 from "tslib";
import { HttpParams } from '@angular/common/http';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../core/services/ls-helper.service";
import * as i4 from "./transaction.service";
export class TransactionRequirementService extends BaseProvider {
    constructor(globals, http, ls, transactionService) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.transactionService = transactionService;
        this.documentViewerIsVisible = false;
        this.commentToShow = {
            id: 0,
            comment: null
        };
        this.pdfCommunicator = new Subject();
        this.someFinishPending = false;
        this.commentReviewField = '';
        this.hideActionButton = false;
        this.incompleteCount = 0;
        this.openedByTechnician = false;
        /** Coherente con ngx-extended-pdf-viewer 9.x + flujo admin Ver archivo. */
        this.pdfViewSessionId = 0;
        this.activePdfObjectUrl = null;
        /**
         * Ciudadano: tras clic en "Mostrar Formulario" cuando abre PDF (`showFile`),
         * el `pdf-viewer` imprime en consola los campos AcroForm una vez al cargar.
         */
        this.logPdfAcroFieldsAfterCitizenOpen = false;
        this.currentRequirement = [];
        this.formData = {};
        /**
         * Caché de URLs para imágenes (evita descargar varias veces la misma imagen)
         */
        this.imageUrlCache = {};
        /**
         * Caché de promesas en curso (evita iniciar múltiples peticiones para la misma imagen)
         */
        this.pendingRequests = {};
        this.baseUrl = 'userProcessRequirement';
        this.list = [];
    }
    resetComment() {
        this.commentToShow = {
            id: 0,
            comment: null
        };
    }
    /**
     * Actualiza un requisito en la lista fusionando los datos del servidor con el ítem existente.
     * Así no se pierden campos (ej. RequirementTypeId, RequirementName) y el requisito no desaparece de la vista.
     */
    updateRequirementInList(updatedItem) {
        if (!updatedItem || updatedItem.UserProcessRequirementId == null)
            return;
        const id = updatedItem.UserProcessRequirementId;
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].UserProcessRequirementId === id) {
                this.list[i] = Object.assign({}, this.list[i], updatedItem);
                return;
            }
        }
    }
    requiredRequirementsAreCompleteFE() {
        const incompleteRequirementList = this.list.filter(d => {
            if (!d.IsComplete && d.SettingName === 'Required') {
                return true;
            }
        });
        if (incompleteRequirementList.length > 0) {
            return true;
        }
    }
    requirementIncompleteCount(userProcessId) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/${userProcessId}/incompleteCount`;
            this.http.get(this.url).subscribe((data) => {
                resolve(data);
                this.incompleteCount = data.Data.RequirementIncompleteCount;
            }, (err) => { reject(err); });
        });
    }
    getRequirements(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/tecnico/process/' + id;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.list = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getProponentRequirementsSnapshot(userProcessId) {
        return new Promise((resolve, reject) => {
            const url = this.globals.dataUrl + this.baseUrl + '/proponente/process/' + userProcessId;
            this.http.get(url).subscribe((data) => resolve(data.Data || []), err => reject(err));
        });
    }
    revokeActivePdfBlob() {
        if (this.activePdfObjectUrl) {
            try {
                window.URL.revokeObjectURL(this.activePdfObjectUrl);
            }
            catch (e) { /* ignore */ }
            this.activePdfObjectUrl = null;
        }
    }
    clearPdfFileCaches() {
        this.imageUrlCache = {};
        this.pendingRequests = {};
    }
    closePdfView() {
        this.revokeActivePdfBlob();
        this.fileToLoad = null;
        this.formData = {};
        this.clearPdfFileCaches();
    }
    beginPdfViewSession() {
        this.revokeActivePdfBlob();
        this.fileToLoad = null;
        this.formData = {};
        this.clearPdfFileCaches();
        this.logPdfAcroFieldsAfterCitizenOpen = false;
        return ++this.pdfViewSessionId;
    }
    /**
     * Misma regla que en "Ver archivo": excluye null, undefined, '' y false.
     * Debe usarse antes de getPdf para que el visor no monte con datos viejos o vacíos.
     */
    parsePdfFormJsonToFilteredFormData(pdfFormJson) {
        const out = {};
        if (pdfFormJson == null || pdfFormJson === '') {
            return out;
        }
        try {
            const parsed = JSON.parse(pdfFormJson);
            if (!parsed || typeof parsed !== 'object') {
                return out;
            }
            for (const key in parsed) {
                if (!Object.prototype.hasOwnProperty.call(parsed, key)) {
                    continue;
                }
                const value = parsed[key];
                if (value !== null &&
                    value !== undefined &&
                    value !== '' &&
                    value !== false) {
                    out[key] = value;
                }
            }
        }
        catch (_a) {
            /* ignore */
        }
        return out;
    }
    commitPdfViewIfCurrent(sessionId, blobUrl) {
        if (sessionId !== this.pdfViewSessionId) {
            try {
                window.URL.revokeObjectURL(blobUrl);
            }
            catch (e) { /* ignore */ }
            return false;
        }
        this.revokeActivePdfBlob();
        this.activePdfObjectUrl = blobUrl;
        this.fileToLoad = blobUrl;
        return true;
    }
    fetchPdfBlobUrl(fileName) {
        const queryParams = new HttpParams().set('fileName', fileName.toString());
        const reqUrl = this.globals.dataUrl + this.baseUrl + '/file';
        return new Promise((resolve, reject) => {
            this.http
                .get(reqUrl, { responseType: 'arraybuffer', params: queryParams })
                .subscribe((data) => {
                const blob = new Blob([data], { type: 'application/pdf' });
                resolve(window.URL.createObjectURL(blob));
            }, err => reject(err));
        });
    }
    getProponentRequirements(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/proponente/process/' + id;
            this.http
                .get(this.url)
                .subscribe((data) => {
                // Actualizo comentario a mostrar en listado requisitos
                if (this.commentToShow.id > 0) {
                    const commentReq = data.Data.filter(req => req.UserProcessRequirementId === this.commentToShow.id)[0].Comment;
                    if (commentReq) {
                        this.commentToShow.comment = commentReq;
                    }
                    else {
                        this.resetComment();
                    }
                }
                this.list = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getFilledPdf(requirementId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/filledPdf/' + requirementId;
            this.http
                .get(this.url, { responseType: 'arraybuffer' })
                .subscribe((data) => { resolve(data); }, err => { reject(err); });
        });
    }
    getPdf(id, fileType, autoLoad) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = new HttpParams()
                .set('fileName', id.toString());
            return yield new Promise((resolve, reject) => {
                this.url = this.globals.dataUrl + this.baseUrl + '/file';
                this.http
                    .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                    .subscribe((data) => {
                    const url = this.downLoadFile(data, fileType, autoLoad, id.toString());
                    resolve(url);
                }, err => { reject(err); });
            });
        });
    }
    getImage(imageFileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = new HttpParams()
                .set('fileName', imageFileName);
            return yield new Promise((resolve, reject) => {
                this.url = this.globals.dataUrl + this.baseUrl + '/file';
                this.http
                    .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                    .subscribe((data) => {
                    // Determinar el tipo de imagen basado en la extensión
                    const fileExtension = imageFileName.split('.').pop().toLowerCase();
                    let fileType = 'image/jpeg';
                    if (fileExtension === 'png') {
                        fileType = 'image/png';
                    }
                    else if (fileExtension === 'gif') {
                        fileType = 'image/gif';
                    }
                    // Crear un blob y una URL para la imagen
                    const blob = new Blob([data], { type: fileType });
                    const url = window.URL.createObjectURL(blob);
                    resolve(url);
                }, err => { reject(err); });
            });
        });
    }
    downLoadFile(data, type, autoLoad, fileName) {
        const blob = new Blob([data], { type });
        const url = window.URL.createObjectURL(blob);
        if (autoLoad) {
            this.fileToLoad = url;
        }
        else {
            // Crear un enlace temporal
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            // Añadir el enlace al documento
            document.body.appendChild(link);
            // Simular el clic para iniciar la descarga
            link.click();
            // Limpiar
            window.URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
            return;
        }
        return url;
    }
    updatePdfFormInternal(params, formData) {
        return new Promise((resolve, reject) => {
            // Construcción de la URL con query string
            this.url = `${this.globals.dataUrl}${this.baseUrl}/internal/userProcess/${params.userProcessId}/userProcessRequirement/${params.userProcessRequirementId}`;
            this.http.put(this.url, formData)
                .subscribe(response => {
                resolve(response);
            }, (err) => {
                reject(err);
            });
        });
    }
    uploadRequirementFile(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/file';
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                this.transactionService.getById(this.transactionService.itemToEdit.Id);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    markAsRevised(requirementId, flag) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl + '/revision/' + requirementId + '/hasForm/' + flag;
            this.http
                .post(this.url, null)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    savePdfFormJson(formData) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/savePdfFormJson`;
            this.http
                .post(this.url, formData)
                .subscribe((data) => {
                this.transactionService.getById(this.transactionService.itemToEdit.Id);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    newUloadRequirementFile(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/addFile';
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                this.transactionService.getById(this.transactionService.itemToEdit.Id);
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    /**
     * Obtiene la URL para un archivo con sistema de caché eficiente
     * @param fileName Nombre del archivo a descargar
     * @returns Promesa con la URL para usar en CSS o src
     */
    getUrlFromGenericFile(fileName) {
        // Si ya está en caché, devolver inmediatamente como promesa resuelta
        if (this.imageUrlCache[fileName]) {
            return Promise.resolve(this.imageUrlCache[fileName]);
        }
        // Si ya hay una petición en curso para este archivo, devolver esa promesa
        if (this.pendingRequests[fileName]) {
            return this.pendingRequests[fileName];
        }
        // Crear una nueva petición y guardarla en pendingRequests
        const queryParams = new HttpParams()
            .set('fileName', fileName);
        const request = new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/file';
            this.http
                .get(this.url, { responseType: 'arraybuffer', params: queryParams })
                .subscribe((data) => {
                try {
                    // Determinar el tipo MIME basado en la extensión
                    const fileExtension = fileName.split('.').pop().toLowerCase();
                    let mimeType = this.getMimeTypeFromExtension(fileExtension);
                    // Crear un blob y una URL para el archivo
                    const blob = new Blob([data], { type: mimeType });
                    const url = window.URL.createObjectURL(blob);
                    // Guardar en caché antes de resolver
                    this.imageUrlCache[fileName] = url;
                    // Eliminar de pendientes
                    delete this.pendingRequests[fileName];
                    resolve(url);
                }
                catch (error) {
                    console.error('Error procesando archivo:', error);
                    delete this.pendingRequests[fileName];
                    reject(error);
                }
            }, err => {
                console.error('Error al obtener el archivo:', err);
                delete this.pendingRequests[fileName];
                reject(err);
            });
        });
        // Guardar la promesa en pendingRequests
        this.pendingRequests[fileName] = request;
        return request;
    }
    /**
     * Limpia todos los datos relacionados con los requisitos
     * Se llama cuando se abandona el componente transaction-management
     */
    clearRequirementData() {
        this.revokeActivePdfBlob();
        this.documentViewerIsVisible = false;
        this.commentToShow = {
            id: 0,
            comment: null
        };
        this.UserProcessRequirementId = null;
        this.ProcessId = null;
        this.fileToLoad = null;
        this.FileName = null;
        this.RequirementTypeName = null;
        this.IsFlagedForVerification = null;
        this.someFinishPending = false;
        this.commentReviewField = '';
        this.hideActionButton = false;
        this.incompleteCount = 0;
        this.openedByTechnician = false;
        this.currentRequirement = [];
        this.formData = {};
        this.list = [];
        // Limpiar caché de imágenes
        this.imageUrlCache = {};
        this.pendingRequests = {};
        // Limpiar pdfCommunicator
        this.pdfCommunicator = new Subject();
        console.log('TransactionRequirementService: datos limpiados');
    }
    /**
     * Obtiene el tipo MIME basado en la extensión del archivo
     * @param extension Extensión del archivo
     * @returns Tipo MIME correspondiente
     */
    getMimeTypeFromExtension(extension) {
        const mimeTypes = {
            'pdf': 'application/pdf',
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'ppt': 'application/vnd.ms-powerpoint',
            'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'txt': 'text/plain',
            'csv': 'text/csv',
            'html': 'text/html',
            'xml': 'application/xml',
            'zip': 'application/zip',
            'rar': 'application/x-rar-compressed'
        };
        return mimeTypes[extension] || 'application/octet-stream';
    }
    /**
     * Obtiene una URL para usar como background-image con imágenes almacenadas en caché
     * @param fileName Nombre del archivo a descargar
     * @returns Promesa con la URL para usar en CSS
     */
    getBackgroundImageUrl(fileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // Si ya está en caché, devolver inmediatamente
            if (this.imageUrlCache[fileName]) {
                return this.imageUrlCache[fileName];
            }
            try {
                // Obtener la URL y guardarla en caché
                const url = yield this.getUrlFromGenericFile(fileName);
                this.imageUrlCache[fileName] = url;
                return url;
            }
            catch (error) {
                console.error('Error al obtener imagen de fondo:', error);
                // Devolver una URL vacía o alguna imagen por defecto en caso de error
                return 'assets/images/default-placeholder.png';
            }
        });
    }
}
TransactionRequirementService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionRequirementService_Factory() { return new TransactionRequirementService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.TransactionService)); }, token: TransactionRequirementService, providedIn: "root" });
